<div class="page-wrapper">
  <div class="content-wrapper pagenotfound-content-wrapper">
    <div class="title">
      <h1>Error 404</h1>
    </div>
    <div class="primary-border">
      <h1 class="pagenotfound-title">{{ pageData.title }}</h1>
      <div class="pagenotfound-content">{{ pageData.content }}</div>
      <div class="pagenotfound-links">
        <div
          class="pagenotfound-link"
          *ngFor="let link of pageData.links; let first = first"
        >
          <a [href]="link.link ?? link.route">
            <button class="button">{{ link.label }}</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
